import { exchangeMembershipApplicaionsAPI } from '@/api/admin/exchangeMembershipApp';

const state = () => ({
  draftsList: [],
  draftsListPageCount: 0,
  draftsListCount: 0,
  inProgressList: [],
  inProgressListPageCount: 0,
  inProgressListCount: 0,
  confirmedList: [],
  confirmedListPageCount: 0,
  confirmedListCount: 0,
  declinedList: [],
  declinedListPageCount: 0,
  declinedListCount: 0,
})

const mutations = {
  setDraftsList (state, data) {
    state.draftsList = data.exchangeMembershipApps
    state.draftsListPageCount = data.pageCount;
    state.draftsListCount = data.exchangeMembershipAppsCount;
  },
  setInProgressList (state, data) {
    state.inProgressList = data.exchangeMembershipApps;
    state.inProgressListPageCount = data.pageCount;
    state.inProgressListCount = data.exchangeMembershipAppsCount;
  },
  setConfirmedList (state, data) {
    state.confirmedList = data.exchangeMembershipApps;
    state.confirmedListPageCount = data.pageCount;
    state.confirmedListCount = data.exchangeMembershipAppsCount;
  },
  setDeclinedList (state, data) {
    state.declinedList = data.exchangeMembershipApps;
    state.declinedListPageCount = data.pageCount;
    state.declinedListCount = data.exchangeMembershipAppsCount;
  },
}

const actions = {
  async getDraftsList ({commit}, data) {
    try {
      const result = await exchangeMembershipApplicaionsAPI.getExchangeMembershipApplicaions('1', data.pageNumber, data.pageSize);
      commit('setDraftsList', result.data);
    } catch (e) {
      console.log('e', e)
    }
  },
  async getInProgressList ({commit}, data) {
    try {
      const result = await exchangeMembershipApplicaionsAPI.getExchangeMembershipApplicaions('2', data.pageNumber, data.pageSize);
      commit('setInProgressList', result.data);
    } catch (e) {
      console.log('e', e)
    }
  },
  async getConfirmedList ({commit}, data) {
    try {
      const result = await exchangeMembershipApplicaionsAPI.getExchangeMembershipApplicaions('3', data.pageNumber, data.pageSize);
      commit('setConfirmedList', result.data);
    } catch (e) {
      console.log('e', e)
    }
  },
  async getDeclinedList ({commit}, data) {
    try {
      const result = await exchangeMembershipApplicaionsAPI.getExchangeMembershipApplicaions('4', data.pageNumber, data.pageSize);
      commit('setDeclinedList', result.data);
    } catch (e) {
      console.log('e', e)
    }
  },
  async createExchangeMembership ({commit}, appId) {
    try {
      return await exchangeMembershipApplicaionsAPI.createExchangeMembership(appId);
    } catch (e) {
      console.log('e', e)
    }
  },
  async createNewAccountAndExchangeMembership ({commit}, appId) {
    try {
      return await exchangeMembershipApplicaionsAPI.createNewAccountAndExchangeMembership(appId);
    } catch (e) {
      console.log('e', e)
    }
  },
  async linkAccountAndCreateExchangeMembership ({commit}, data) {
    try {
      return await exchangeMembershipApplicaionsAPI.linkAccountAndCreateExchangeMembership(data);
    } catch (e) {
      console.log('e', e)
    }
  },
  async declineExchangeMembershipApp ({commit}, appId) {
    try {
      return await exchangeMembershipApplicaionsAPI.declineExchangeMembershipApp(appId);
    } catch (e) {
      console.log('e', e)
    }
  },
}

export default {
  state,
  mutations,
  actions,
}